import styles from "./Banner.module.css";
import {
  PiGithubLogo,
  PiGithubLogoFill,
  PiLinkedinLogo,
  PiLinkedinLogoFill,
} from "react-icons/pi";
import { IoMailOutline, IoMail } from "react-icons/io5";

function Links({ onContactClick }) {
  return (
    <div className={styles.links}>
      <a
        className={styles.iconLink}
        href="https://github.com/Steedie"
        target="_blank"
        rel="noreferrer"
      >
        <span className={styles.iconStack}>
          <PiGithubLogo className={`${styles.icon} ${styles.outline}`} />
          <PiGithubLogoFill className={`${styles.icon} ${styles.filled}`} />
        </span>
        GitHub
      </a>
      <a
        className={styles.iconLink}
        href="https://www.linkedin.com/in/joshsteede/"
        target="_blank"
        rel="noreferrer"
      >
        <span className={styles.iconStack}>
          <PiLinkedinLogo className={`${styles.icon} ${styles.outline}`} />
          <PiLinkedinLogoFill className={`${styles.icon} ${styles.filled}`} />
        </span>
        LinkedIn
      </a>
      <button
        className={styles.iconLink}
        type="button"
        onClick={onContactClick}
      >
        <span className={styles.iconStack}>
          <IoMailOutline className={`${styles.icon} ${styles.outline}`} />
          <IoMail className={`${styles.icon} ${styles.filled}`} />
        </span>
        Contact
      </button>
    </div>
  );
}

function Banner({ onContactClick }) {
  return (
    <div className={styles.banner}>
      <div className={styles.left}>
        <div className={styles.eyebrow}>Josh Steede</div>
        <h1 className={styles.title}>
          Full Stack Developer building thoughtful products across web, games,
          and AI.
        </h1>
        <p className={styles.subtitle}>
          Shipping polished frontends, reliable backends, and interactive
          experiences with a strong product and gameplay sensibility.
        </p>
        <div className={styles.highlights}>
          <span>UK based</span>
          <span>React and TypeScript</span>
          <span>Unity and Unreal</span>
        </div>
      </div>

      <div className={styles.right}>
        <div className={styles.panelLabel}>Currently building at Radioplayer</div>
        <div className={styles.panelTitle}>
          Focused on shipping product, platform, and interactive work.
        </div>
        <div className={styles.panelDescription}>
          This portfolio highlights the work, systems, and experiments I have
          been building across web, games, and AI.
        </div>
        <Links onContactClick={onContactClick} />
      </div>
    </div>
  );
}

export default Banner;
